import { api } from '@/services/backend/http-client';

// THEQA SSO or mobile PKI, as GUP sent it.
export type GupAuthMethod = 'theqa' | 'mpki';

export type GupRedirectParams = {
  serviceId: string | null;
  crNumber?: string | null;
  lang: 'en' | 'ar';
  callbackUrl: string;
  // null when the backend does not pass the value on.
  authMethod: GupAuthMethod | null;
  source: 'GUP' | 'ANDROID' | 'IPHONE' | 'HUAWEI';
};

export const decryptGupRequest = async (encRequest: string): Promise<GupRedirectParams> => {
  const response = await api.post<GupRedirectParams>(
    '/integration/gup/url/decrypt',
    { encRequest },
    {
      responseInterceptorConfig: { ignoreStatusCodes: [400, 422, 503] },
    },
  );
  return response.data;
};
